import { useState, useEffect } from 'react';
import './ForgotPassword.css'
import { Box, Stack, TextField, Button } from "@mui/material";
import { generateOTP, validateOTP, ChangePwd } from '../../api/api'
import toast from 'react-hot-toast'
import { useNavigate } from "react-router-dom";


export default function ForgotPassword() {
    const [loading, setLoading] = useState(false);
    const [verifyOTP, setVerifyOTP] = useState(false);
    const [changePassword, setChangePassword] = useState(false);
    const [mobileNumber, setMobileNumber] = useState(""); // Store mobile number
    const [userId, setUserId] = useState(""); // Store user_id from OTP response
    const navigate = useNavigate();

    // for resend
    const [resendTimer, setResendTimer] = useState(0);
    const [canResend, setCanResend] = useState(false);


    // Step 1: Send OTP Payload
    const [sendOtpPayload, setSendOtpPayload] = useState({
        RBAuthKey: "RBDWAh!Q1s74e",
        mobile_no: "",
    });
    console.log("sendOtpPayload==>", sendOtpPayload);


    // Step 2: Verify OTP Payload
    const [verifyOtpPayload, setVerifyOtpPayload] = useState({
        OTP: ""
    });
    console.log("verifyOtpPayload==>", verifyOtpPayload);


    // Step 3: Change Password Payload
    const [changePasswordPayload, setChangePasswordPayload] = useState({
        Password: "",
        confirmPassword: ""
    });
    console.log("changePasswordPayload==>", changePasswordPayload);

    // resend otp 
    // Timer effect for resend OTP
    useEffect(() => {
        let interval;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((prev) => {
                    if (prev <= 1) {
                        setCanResend(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [resendTimer]);

    // Start timer when OTP is sent
    const startResendTimer = () => {
        setResendTimer(30); // 30 seconds timer
        setCanResend(false);
    };



    // ==================== STEP 1: SEND OTP ====================
    const handleSendOtpSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (sendOtpPayload.mobile_no.length !== 10) {
            toast.error("Please enter a valid 10-digit mobile number");
            return;
        }

        CallGenerateOtp();
    }

    const handleSendOtpChange = (e) => {
        if (e.target.name === "mobile_no") {
            e.target.value = e.target.value.replace(/\D/g, "");
        }
        setSendOtpPayload({ ...sendOtpPayload, [e.target.name]: e.target.value });
    }

    const CallGenerateOtp = async () => {
        try {
            setLoading(true);

            const res = await generateOTP(sendOtpPayload);

            console.log("Generate OTP Response:", res?.data);

            if (res?.data?.status?.toLowerCase() === "success") {
                const successMessage = res?.data?.message || "OTP sent successfully";
                toast.success(successMessage);

                // Store mobile number and user_id for next steps
                setMobileNumber(sendOtpPayload.mobile_no);

                // Store user_id if provided in response
                if (res?.data?.user_id) {
                    setUserId(res.data.user_id);
                } else if (res?.data?.data?.user_id) {
                    setUserId(res.data.data.user_id);
                }

                // Move to OTP verification step
                setVerifyOTP(true);
                // resend otp 
                startResendTimer();

            } else {
                const errorMessage = res?.data?.message || "Failed to send OTP. Please try again.";
                toast.error(errorMessage);
            }
        } catch (err) {
            console.error("Error sending OTP:", err);
            const errorMsg = err?.response?.data?.message || "Server error. Please try again later.";
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    // resend otp 
    // ==================== RESEND OTP ====================
    const handleResendOtp = async () => {
        if (!canResend || loading) return;

        try {
            setLoading(true);

            // Clear the previous OTP input
            setVerifyOtpPayload({ OTP: "" });

            const res = await generateOTP(sendOtpPayload);

            console.log("Resend OTP Response:", res?.data);

            if (res?.data?.status?.toLowerCase() === "success") {
                const successMessage = res?.data?.message || "OTP resent successfully";
                toast.success(successMessage);

                // Update user_id if provided in response
                if (res?.data?.user_id) {
                    setUserId(res.data.user_id);
                } else if (res?.data?.data?.user_id) {
                    setUserId(res.data.data.user_id);
                }

                startResendTimer(); // Restart the timer
            } else {
                const errorMessage = res?.data?.message || "Failed to resend OTP. Please try again.";
                toast.error(errorMessage);
            }
        } catch (err) {
            console.error("Error resending OTP:", err);
            const errorMsg = err?.response?.data?.message || "Server error. Please try again later.";
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };



    // ==================== STEP 2: VERIFY OTP ====================
    const handleOtpSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (!verifyOtpPayload.OTP || verifyOtpPayload.OTP.length < 4) {
            toast.error("Please enter a valid OTP");
            return;
        }


        CallValidateOTP();
    }

    const handleOtpChange = (e) => {
        if (e.target.name === "OTP") {
            e.target.value = e.target.value.replace(/\D/g, "");
        }
        setVerifyOtpPayload({ ...verifyOtpPayload, [e.target.name]: e.target.value });
    }

    const CallValidateOTP = async () => {
        try {
            setLoading(true);

            // Construct payload based on what the API expects
            const payload = {
                RBAuthKey: "RBDWAh!Q1s74e",
                user_id: userId || mobileNumber, // Use stored user_id or mobile number as fallback
                OTP: verifyOtpPayload.OTP,
                Reg_status: "1"
            };

            console.log("Validate OTP Payload:", payload);

            const res = await validateOTP(payload);

            console.log("Validate OTP Response:", res?.data);

            if (res?.data?.status?.toLowerCase() === "success") {
                const successMessage = res?.data?.message || "OTP verified successfully";
                toast.success(successMessage);

                // Move to change password step
                setVerifyOTP(false);
                setChangePassword(true);
            } else {
                const errorMessage = res?.data?.message || "Invalid OTP. Please try again.";
                toast.error(errorMessage);
            }
        } catch (err) {
            console.error("Error verifying OTP:", err);
            const errorMsg = err?.response?.data?.message || "Failed to verify OTP. Please try again.";
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    const handleBackToMobile = () => {
        setVerifyOTP(false);
        // resend otp 
        setResendTimer(0);
        setCanResend(false);
        // resend otp // 
        setSendOtpPayload({ RBAuthKey: "RBDWAh!Q1s74e", mobile_no: "" });
        setVerifyOtpPayload({ OTP: "" });
    }

    // ==================== STEP 3: CHANGE PASSWORD ====================
    const handlePasswordSubmit = (e) => {
        e.preventDefault();

        // Validate passwords
        if (!changePasswordPayload.Password || changePasswordPayload.Password.trim() === "") {
            toast.error("Password cannot be empty");
            return;
        }

        if (changePasswordPayload.Password.length < 6) {
            toast.error("Password must be at least 6 characters long");
            return;
        }

        if (changePasswordPayload.Password !== changePasswordPayload.confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        CallChangePwd();
    }

    const handlePasswordChange = (e) => {
        setChangePasswordPayload({ ...changePasswordPayload, [e.target.name]: e.target.value });
    }

    const CallChangePwd = async () => {
        try {
            setLoading(true);

            // Prepare payload with mobile number
            const payload = {
                RBAuthKey: "RBDWAh!Q1s74e",
                Mobile_No: mobileNumber, // Use stored mobile number
                Pat_status: "1",
                Password: changePasswordPayload.Password
            };

            console.log("Change Password Payload:", payload);

            const res = await ChangePwd(payload);

            console.log("Change Password Response:", res?.data);

            {/*if (res?.data?.status?.toLowerCase() === "success") {
                const successMessage = res?.data?.message || "Password changed successfully";
                toast.success(successMessage);
                
                // Reset all states after 2 seconds
                setTimeout(() => {
                    resetAllStates();
                    // Optionally redirect to login
                    // window.location.href = "/login";
                }, 2000);*/}


            if (res?.data?.status?.toLowerCase() === "success") {
                const successMessage = res?.data?.message || "Password changed successfully";
                toast.success(successMessage);

                setTimeout(() => {
                    resetAllStates();
                    navigate("/users/login");   // ⭐ Redirect user to login page
                }, 1500);


            } else {
                const errorMessage = res?.data?.message || "Failed to change password. Please try again.";
                toast.error(errorMessage);
            }
        } catch (err) {
            console.error("Error changing password:", err);
            const errorMsg = err?.response?.data?.message || "Server error. Please try again later.";
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    const resetAllStates = () => {
        setVerifyOTP(false);
        setChangePassword(false);
        setMobileNumber("");
        setUserId("");
        // resend otp 
        setResendTimer(0);
        setCanResend(false);
        // resend otp // 
        setSendOtpPayload({ RBAuthKey: "RBDWAh!Q1s74e", mobile_no: "" });
        setVerifyOtpPayload({ OTP: "" });
        setChangePasswordPayload({ Password: "", confirmPassword: "" });
    }

    return (
        <>
            {/* <div className="NewsMainContainer"> */}
                <div className="NewsMainContainer forgetPass-Container">
                    <div className="Request-DeletionCard">
                        <div className="formSection">

                            {/* STEP 1: Send OTP Form */}
                            {!verifyOTP && !changePassword && (
                                <Box component="form" onSubmit={handleSendOtpSubmit}
                                    sx={{ maxWidth: 300, margin: '0 auto' }}>
                                    <h1 className="account-deletion-title">Forgot Password</h1>
                                    <p style={{ textAlign: "center", marginBottom: "20px", color: "#666" }}>
                                        Enter your mobile number to receive OTP
                                    </p>
                                    <Stack direction="column" spacing={1.5} alignItems="center">

                                        {/* Full-width wrapper for TextField */}
                                        <Box width="100%">
                                            <TextField
                                                label="Mobile Number"
                                                name="mobile_no"
                                                type="tel"
                                                inputProps={{
                                                    maxLength: 10,
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]*"
                                                }}
                                                value={sendOtpPayload.mobile_no}
                                                onChange={handleSendOtpChange}
                                                fullWidth
                                                required
                                                size="small"
                                                placeholder="Enter 10-digit mobile number"
                                            />
                                        </Box>

                                        {/* Centered Button */}
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="medium"
                                            disabled={loading || sendOtpPayload.mobile_no.length !== 10}
                                            sx={{
                                                maxWidth: 200,
                                                borderRadius: 1.5,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                py: 0.8,
                                                mt: 1
                                            }}
                                        >
                                            {loading ? "Sending OTP..." : "Send OTP"}
                                        </Button>

                                    </Stack>

                                </Box>)}




                            {verifyOTP && !changePassword && (
                                <Box component="form" onSubmit={handleOtpSubmit} sx={{ maxWidth: 300, margin: "0 auto" }}>
                                    <h1 className="account-deletion-title">Verify OTP</h1>
                                    <p style={{ textAlign: "center", marginBottom: "20px", color: "#666" }}>
                                        OTP has been sent to <strong>{mobileNumber}</strong>
                                    </p>

                                    <Stack direction="column" spacing={1.5} alignItems="center">

                                        {/* Full-width input */}
                                        <Box width="100%">
                                            <TextField
                                                label="Enter OTP"
                                                name="OTP"
                                                type="tel"
                                                inputProps={{
                                                    maxLength: 6,
                                                    inputMode: "numeric",
                                                    pattern: "[0-9]*",
                                                }}
                                                value={verifyOtpPayload.OTP}
                                                onChange={handleOtpChange}
                                                fullWidth
                                                required
                                                size="small"
                                                placeholder="Enter 4-digit OTP"
                                                autoFocus
                                            />
                                        </Box>

                                        {/* Centered Button with same size */}
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="medium"
                                            disabled={loading || !verifyOtpPayload.OTP}
                                            sx={{
                                                maxWidth: 200,
                                                borderRadius: 1.5,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                py: 0.8,
                                                mt: 1
                                            }}
                                        >
                                            {loading ? "Verifying..." : "Verify OTP"}
                                        </Button>

                                        {/* resend otp  */}
                                        <Box sx={{ textAlign: 'center', width: '100%' }}>
                                            {resendTimer > 0 ? (
                                                <p style={{ fontSize: '14px', color: '#666', margin: '10px 0' }}>
                                                    Resend OTP in {resendTimer}s
                                                </p>
                                            ) : (
                                                <Button
                                                    variant="text"
                                                    size="small"
                                                    onClick={handleResendOtp}
                                                    disabled={loading || !canResend}
                                                    sx={{
                                                        textTransform: "none",
                                                        fontWeight: 600,
                                                        color: "#0ea99cff"
                                                    }}
                                                >
                                                    Resend OTP
                                                </Button>
                                            )}
                                        </Box>

                                        {/* Centered link button */}
                                        <Button
                                            variant="text"
                                            size="small"
                                            onClick={handleBackToMobile}
                                            disabled={loading}
                                            sx={{ textTransform: "none", color: "#0ea99cff" }}
                                        >
                                            ← Change Mobile Number
                                        </Button>

                                    </Stack>
                                </Box>
                            )}




                            {!verifyOTP && changePassword && (
                                <Box component="form" onSubmit={handlePasswordSubmit} sx={{ maxWidth: 300, margin: "0 auto" }}>
                                    <h1 className="account-deletion-title">Create New Password</h1>
                                    <p style={{ textAlign: "center", marginBottom: "20px", color: "#666" }}>
                                        Enter your new password for <strong>{mobileNumber}</strong>
                                    </p>

                                    <Stack direction="column" spacing={1.5} alignItems="center">

                                        {/* Full-width input */}
                                        <Box width="100%">
                                            <TextField
                                                label="New Password"
                                                name="Password"
                                                type="password"
                                                value={changePasswordPayload.Password}
                                                onChange={handlePasswordChange}
                                                fullWidth
                                                required
                                                size="small"
                                                placeholder="Minimum 6 characters"
                                                autoFocus
                                            />
                                        </Box>

                                        <Box width="100%">
                                            <TextField
                                                label="Confirm Password"
                                                name="confirmPassword"
                                                type="password"
                                                value={changePasswordPayload.confirmPassword}
                                                onChange={handlePasswordChange}
                                                fullWidth
                                                required
                                                size="small"
                                                placeholder="Re-enter password"
                                            />
                                        </Box>

                                        {/* Centered Button with same size */}
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="medium"
                                            disabled={loading || !changePasswordPayload.Password || !changePasswordPayload.confirmPassword}
                                            sx={{
                                                maxWidth: 200,
                                                borderRadius: 1.5,
                                                textTransform: "none",
                                                fontWeight: 600,
                                                py: 0.8,
                                                mt: 1
                                            }}
                                        >
                                            {loading ? "Updating Password..." : "Update Password"}
                                        </Button>

                                    </Stack>
                                </Box>
                            )}

                        </div>
                    </div>
                </div>
            {/* </div> */}
        </>
    )
}